import { CrystalTripDTO } from 'business/models/Models';
import { CrystalDrawing } from 'components/well/drawingManager/constants';

export const isCrystalLocked = (crystals: CrystalDrawing[], crystalId: number) => {
  return crystals?.filter((x) => x.id === crystalId)[0]?.locked;
};

export const isCrystalApplicableForCopy = (
  crystals: CrystalDrawing[],
  checkedCrystals: number[],
) => {
  return (
    checkedCrystals.length === 1 &&
    crystals.filter(
      (x) =>
        x.id === checkedCrystals[0] && (x.cryoprotectants?.length || x.soakings?.length),
    )?.length > 0
  );
};

export const getSelectedTripIdByCrystalId = (
  crystalTrips: CrystalTripDTO[],
  crystalId: number,
) => {
  const tripId = crystalTrips.filter((x) => x.crystalId === crystalId)[0]
    ?.synchrotronTripId;
  return !tripId ? 0 : tripId;
};
